// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: "false",
  integrationServiceAllowed: "false",
  Equifax: true,
  serverTimeZone: '+00:00',
  env: "local",
  demo: "true",
  simulators: "false",
  ipifyEnabled: "false",
  pilotEnabled: "false",
  appVersion: "2.1.0",
  lastBuildDate: "2022-03-04",
  appInsights: {
    instrumentationKey: '3fd6209b-ac1f-48de-ab99-86cd77049ec9',
  },
  api: {
    auth: "http://ec2-52-220-124-231.ap-southeast-1.compute.amazonaws.com/user-service/auth",
    getquestionandAnsChoice: "authenticationUtil/partyAuthentication/questionsStub/",
    assessmentScore: "authenticationUtil/partyAuthentication/assessmentScore",
    getIpUrl: "https://api64.ipify.org/?format=json",
    Json_Load_URL: 'http://ec2-52-220-124-231.ap-southeast-1.compute.amazonaws.com/config-service/getModuleJSONList',
    enumURL: 'http://ec2-52-220-124-231.ap-southeast-1.compute.amazonaws.com/masters-service/getKeyCodes',
    pre_approval_url_en: 'https://www.cibc.com/ca/apply/mortgages/mortgage-index.html?requestType=preapproval',
    pre_approval_url_fr: 'https://www.cibc.com/ca/apply/mortgages/mortgage-index-fr.html?requestType=preapproval}',
    signOnURL: 'https://www.cibconline.cibc.com/ebm-resources/public/banking/cibc/client/web/index.html#/signon',
    signOnURLTokenized: 'ThisIsTokenizedIntrumentationKey',
    olbSignin: 'https://dit11.az.dev.cibconline.cibc.com/ebm-resources/secure-cibc-com-loader-app/client/index.html#/sso?spId=MMORTGAGE&subSiteId=prequalification&',
    secretKey: '',
    encryptedKey: 'RU5DT0RFQVVUSFBSRVFVQQ==',
    mortgageHome_en: 'https://www.cibc.com/en/personal-banking/mortgages.html',
    mortgageHome_fr: 'https://www.cibc.com/fr/personal-banking/mortgages.html',
    loginIDAuth: 'prequal',
    loginPwAuth: 'password',
    enable_callback: 'true',
    googlemapapi: 'AIzaSyAMse_W884M-S2axLd2gWClm2nDzGKt2cE',
    cahSignin: 'https://sit.secure.cibc.com/cah/api/v3/oidc/authorize?',
    authentication: 'cah',
    clientId: '2511'
  },
  cookieBinder: {
    url: 'https://assets.adobedtm.com/986cf825ecbc/ac330aee57d5/launch-759e93c9d7f8-development.min.js'
  },
  methodName: {
    prospectList: 'prospectList',
    prospectSearch: 'prospectSearch'
  },
  configuration: {
    country: 116,
    currencyCode: 'USD',
    date_format: 'MM/DD/YYYY',
    callFromServer: true,
    moduleName: 'Personal Discussion'
  },

  backend_base_url: 'https://dev2online.digitalmmortgage.com/',
  backend_baseSit_url: "https://sitonline.digitalmmortgage.com/",
  isencryptionenabled: 'no'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
